import React from 'react';
import { connect } from 'react-redux';
import numeral from 'numeral';
import { Link } from 'react-router-dom';

export const MembersSummary = ({ memberCount }) => {
  const memberWord = memberCount === 1 ? 'member' : 'members' ;
  // const formattedMembersTotal = numeral(membersTotal / 100).format('0.00');
  // const formattedMembersTotal = `₹${membersTotal}`
  // const convert = (value) => `₹${value}` 
  return (
    <div className='page-header'>
    <div className='content-container'>
      <h1 className='page-header__title'>Viewing <span>{memberCount}</span> {memberWord} of the Family</h1>
      {memberCount === 0 && <p>Please start with Head of the Family and fill details with respect to the Head</p>}
      <div className='page-header__actions'>
      { memberCount === 0 ?  <Link className='button' to={'/create'}>Add Head of the Family</Link>:  <Link className='button' to={'/create'}>Add Member</Link>}
       
      </div>
    </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  const visibleMembers = state.members;

  return {
    memberCount: visibleMembers.length,
  };
};

export default connect(mapStateToProps)(MembersSummary);



// WEBPACK FOOTER //
// ./src/components/MembersSummary.js